import { useQuery } from "@tanstack/react-query";
import { getLoginToken, listRetailShops } from "../core/retailShop.core";

export default function useRetailShops() {
  const loginToken = getLoginToken();

  return useQuery({
    queryKey: ["retailShops"],
    queryFn: () => listRetailShops(),
    enabled: !!loginToken, // Only fetch when logged in
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (React Query v4+ uses gcTime instead of cacheTime)
  });
}
